/**
 * authedFetch — wraps fetch with the current Supabase session's access
 * token in the Authorization: Bearer header. Used by /admin/* and
 * eventually /me data-fetching to authenticate against the role-gated
 * API endpoints (getCurrentUser + requireAdmin in api/_lib/auth.ts).
 *
 * Throws if no active session — callers should gate access via
 * useCurrentUser BEFORE calling, so this throw is just a safety net.
 */

import { supabase } from './supabase/client';

export async function authedFetch(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  const { data, error } = await supabase.auth.getSession();
  if (error) {
    throw new Error(`Failed to read Supabase session: ${error.message}`);
  }
  const token = data.session?.access_token;
  if (!token) {
    throw new Error('No active session — sign in at the portal first.');
  }

  const headers = new Headers(init?.headers);
  headers.set('Authorization', `Bearer ${token}`);
  // Belt-and-suspenders: PostgREST expects content-type when body is JSON.
  if (init?.body && !headers.has('content-type')) {
    headers.set('content-type', 'application/json');
  }

  return fetch(input, { ...init, headers });
}
